<template>
    <div>
        Categories show page
    </div>
</template>

<script>
export default {
    name: 'CategoriesShow',
};
</script>
